/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon24Solid = forwardRef('CheckAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.607 5.127a1.5 1.5 0 0 1 0 2.121L11.358 17.497a3.881 3.881 0 0 1-5.488 0l-3.806-3.805a1.5 1.5 0 1 1 2.122-2.122l3.805 3.806a.881.881 0 0 0 1.246 0l10.249-10.25a1.5 1.5 0 0 1 2.121 0Z" })));
});
